import { createActions, createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'

export const INITIAL_STATE = Immutable({
  view: null,
  data: null
})

const { Types, Creators } = createActions({
  setMapData: ['view', 'data'],
})

const setMapDataReducer = (state, { view, data }) => state
  .set('view', view)
  .set('data', data)

export const mapViewReducer = createReducer(INITIAL_STATE, {
  [Types.SET_MAP_DATA]: setMapDataReducer,
})

export const MapViewTypes = Types
export default Creators



// WEBPACK FOOTER //
// ./src/reducers/mapViewReducer.js